



















































































































































































































































































import { Component, Vue, Watch, Ref} from 'vue-property-decorator';
import { MenuItem } from '@/services/MenuItem';
import LoginPage from '@/components/Pages/LoginPage.vue';
import { General } from './services/General';
import HelpContent from '@/components/HelpContent.vue';
import CookieContent from '@/components/CookieContent.vue';
import UserProfile from '@/components/UserProfile.vue';
import SideMenu from '@/components/SideMenu.vue';
import axios from "axios";
import { saveAs } from 'file-saver';
import { HubConnectionBuilder } from "@microsoft/signalr";
import UserProcess from '@/components/UserProcess.vue';
import {Process} from '@/entity/Process';
import EmergencyContact from './components/EmergencyContact.vue';
import {IReadingConfirmationUserAction} from '@/interfaces/IReadingConfirmationUserAction'

export type Modal = Vue & {
    hide: () => boolean;
}

@Component({
    components: {
        LoginPage,
        HelpContent,
        CookieContent,
        UserProfile,
        UserProcess,
        SideMenu,
        EmergencyContact
    }
})

export default class App extends Vue {
    @Ref() readonly sideMenuRef!: SideMenu;

    connection: any = null;
    selectedRegion: any = null;
    browserNotSupported: boolean = false;
    nameCountry: string = null;
    firstLoadComponent: boolean = true;
    sideActive: boolean = true;        
    mandatoryCommunications = new Array();
    userProcessModalTitle: string = null;
    forceReload: boolean = false;
    selectedLanguage = null;
    languageOptions: Array<any> = [];
    userActionHashMap: Map<string, string> = new Map();
    readingConfirmationUserActions: Array<IReadingConfirmationUserAction> = [];
    confirmed: boolean = false;
    commToConfirm: string = null;
    currentClientVersion: string = null;
        
    @Watch('$store.state.languages')
    async onLanguageChange(){
        await General.loadLanguageFromStoreAsync().then(() =>  {
            this.selectedLanguage = this.$store.getters.getUserProfile.idCulture; 
        }).catch();
        this.forceReload = !this.forceReload; 
    }

    setUserActions(commId, $event) {
        this.userActionHashMap.set(commId, $event);
        this.$forceUpdate();
    }

    resetUserActionRadios() {
        var inputs = document.getElementsByTagName('input');
        for (var i = 0; i < inputs.length; i++) {
            if(inputs[i].checked)
                inputs[i].checked = false;
        }
    }

    async addMultipleUserReadingConfirmation() {
        let app = this;           
        let valid = true;
        this.confirmed = true;
        if(this.userActionHashMap.size == 0) {
            location.href='#pos-'+this.communications[0].id;
            valid = false;
        }
            
        this.readingConfirmationUserActions = new Array<IReadingConfirmationUserAction>();
        this.userActionHashMap.forEach( (value: string, key: string) => {
            let readingConfirmationUserAction: IReadingConfirmationUserAction = {
                communicationId: key,
                actionConfirmation: value
            } 
            this.readingConfirmationUserActions.push(readingConfirmationUserAction);
        });

        if (this.communications.length!=this.readingConfirmationUserActions.length){                
            valid = false;
            location.href='#pos-'+this.commToConfirm;
            
        }


        if (valid==true){
            General.confirm(
                "Do you confirm selected confirm options?",
                this,
                async () => {            
                    try{
                        General.mainLoading(true);
                        await axios({
                            method: 'post',
                            url: General.GetApiUrl("/api/communication/AddMultipleUserReadingConfirmation"),
                            data: this.readingConfirmationUserActions,
                            withCredentials: true,
                        });      
                        app.communications = null;
                                            
                        await General.IsLogged(app);
                        
                        app.userActionHashMap = new Map<string, string>();
                        app.readingConfirmationUserActions = new Array<IReadingConfirmationUserAction>();
                        app.resetUserActionRadios();
                        
                        
                    }catch(error){                        
                        General.HandleError(error, this);        
                    }finally{
                        General.mainLoading(false);
                    
                    }
                }
                
            )
        }else{
            General.showAlertDanger("Please, select at least one option for each communication before confirming", this);
        }
       
    }

    async addUserReadingConfirmation(communicationId: string,actionConfirmation: string){
          General.confirm(
            "Do you want confirm this communication like:" + actionConfirmation + "?",
            this,
            async () => {            
                try{
                General.mainLoading(true);
                await axios.get(General.GetApiUrl("/api/Communication/addUserReadingConfirmation?id="+communicationId + "&actionConfirmation=" + actionConfirmation),{withCredentials: true})
                await General.IsLogged(this);
                }catch(error){                        
                    General.HandleError(error, this);        
                }finally{
                    General.mainLoading(false);
                }
            }
        );
    }
        
    checkPage(pagePath: string): boolean {           
        let pagePathCurrent: string = this.sideMenuRef.cleanUrl(pagePath);
        let currentPath: string = this.sideMenuRef.cleanUrl(this.$router.currentRoute.path);
        if (pagePathCurrent == currentPath) return true;
        return false;
    }

    async downloadAttachmentById(attachment: { id: string; name: any; }){
  
         try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl("/api/communication/DownloadAttachment?id="+attachment.id),
                withCredentials: true,
                responseType: 'blob'
            });
            saveAs(new Blob([response.data]), attachment.name);
        } catch (error) {
            General.showAlertDanger("Download error, please retry. If the problem stll present contact your IT", this);                               
        }
    }

    async logout() {
        try{
            
            await axios.get(General.GetApiUrl('/api/Auth/Logout'));               
            
            let cookies : any = document.cookie;
            console.log("cookies:");
            console.log(cookies);
            General.Logout();
            //this.$router.push('/login');
            this.resetShowMenuItem();
            this.collapseDropdown();
        }catch(error){
            General.showAlertDanger("something wrong", this);                               

        }
    }

    isMenuItemVisible(item: any): boolean {
        let claims = this.$store.state.claimsList;
        return General.CheckAuthorization(item.Claim);
    }
    
    get isHidingCommunicationsDuringImpersonation(): boolean{
        return this.$store.state.isHidingCommunicationDuringImpersonation
    }

    get isImpersonating(): boolean{
        if (this.$store.state.impersonatedBy != null){
            return true;   
        }
        return false; 
    }

    get communications(): Array<any> {
        return this.$store.state.mandatoryCommunications;
    }
    set communications(array:Array<any>){
        this.$store.dispatch('setMandatoryCommunications', array);
         
    }

    get isEmergencyContactExpired(): boolean {
        return this.$store.state.isEmergencyContactExpired;
    }

    set isEmergencyContactExpired(isExpired:boolean) {
        this.$store.commit('setMandatoryCommunications', isExpired)
    }

    get isLogged(): boolean {         
            
        if (this.$route.path == '/document-search') {
            this.sideActive = false;
            

            return true;
        }else if(this.$route.path.startsWith('/emergency-policy')){
            this.sideActive = false;
            return true
        }else if(this.$store.state.isLogged == true){
            return true
        }
        return false;
    }

    get mainLoading(): boolean {
        return this.$store.state.isMainLoading;
    }
    get countrySelected(): string{
        
        if (this.$store.getters.getCountrySelected==null) return "Region undefined1";
        if (this.$store.getters.getCountrySelected.countryFather==null) return "Region undefined2";
        return this.$store.getters.getCountrySelected.countryFather.name;
    }
    sideMenu() {
        if (this.sideActive == true) {
            this.sideActive = false;
            this.resetShowMenuItem();
        } else 
            this.sideActive = true;
    }

    openSideMenu() {
        this.sideActive = true;
    }

    switchSideMenu(){
        
        this.sideActive = !this.sideActive;
        
        
    }

  

    resetShowMenuItem() {
        this.sideMenuRef.navItems.forEach(el=> {
                el.child.forEach(el2=>{
                    if(el.child instanceof MenuItem){
                        el2.Active = false;
                    }

                });

        });
        
    }

    endImpersonation() {
        General.EndImpersonate(this);
    }

    openModalProfileFromApp() {
        this.$bvModal.show('modal-profile-change');
    }
    
    updated() {
        this.selectedLanguage = this.$store.getters.getUserProfile.idCulture;            
        if (this.firstLoadComponent){
            let menu = (this.$refs['menu'] as any)
            if (menu!= null) menu.checkUrl();
        }
        this.firstLoadComponent = false;
    }

    isNeededTopNavbar: boolean = false;

    showCommunicationModal() {
         if(General.CommunicationsIsActive() && this.communications!=null && this.communications.length>0 && !this.isHidingCommunicationsDuringImpersonation){
            this.$bvModal.show('communication-mandatory-modal');
            this.isNeededTopNavbar = true;
         }
         else{ 
            this.$bvModal.hide('communication-mandatory-modal');
            this.isNeededTopNavbar = false;
         }
    }

    hideMandatoryModal(){
        if (this.isImpersonating){
            this.$bvModal.hide('communication-mandatory-modal');
            General.setHideCommunication(this, true);
        }
    }
    showCommunication(){
        if (this.isImpersonating){
            General.setHideCommunication(this, false);
            this.showCommunicationModal();
        }
    }

    async getAvailableLanguage(){
        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl("/api/culture/GetLanguagesForTranslation"),
                withCredentials: true,
                responseType: 'json'
            }); 
            this.languageOptions = response.data;
            this.languageOptions.forEach(el => {
                el.language.name = `${el.language.name} [${el.language.code}-${el.country.code}]`
            });
            this.languageOptions.unshift({ idCulture: null, language: { name: 'Please select a language'}, disabled: true },)

        } catch (error) {
             General.showAlertDanger("Fail to load available languages for translation", this);      
        }
    }

    openUserProcessModal() {
        this.$bvModal.show('user-process-modal');
    }

    async created() {     
        this.connection = new HubConnectionBuilder()
            .withUrl(General.GetApiUrl('/message'))
            .build();
        
        this.connection.start();

        await General.loadLanguageFromStoreAsync().then(() =>  {
            this.forceReload = !this.forceReload; 
            this.selectedLanguage = this.$store.getters.getUserProfile.idCulture; 
        }).catch();

        var app = this;

        app.checkSize();

        
        window.addEventListener('resize', function() {
            app.checkSize();
            
        });
       
    }

    checkSize(){
        if (window.innerWidth<900){
            this.sideActive = false;
           
            
           
           }else if(!(this.$route.path == '/document-search') && !this.$route.path.startsWith('/emergency-policy') ){
            this.sideActive = true;
          
        
           }
           if (this.sideMenuRef) this.sideMenuRef.sideMenu()

    }
    async mounted() {  
        console.log("mount app1")
        try{
            await General.SetUser();             
        }catch{}

        this.showCommunicationModal();
        this.getAvailableLanguage();    

        this.$forceUpdate;
        General.mainLoading(false);

        let isUserLoggedIn = await General.IsLogged(this);
        this.currentClientVersion = this.$store.getters.checkClientVersion;
        if (!isUserLoggedIn) {
            General.Logout();
        }
        console.log("mount app3")       
        let version: number = parseInt(this.$browserDetect.meta.version.replace('.', ''));

        if (this.$browserDetect.isIE ||
            (this.$browserDetect.isEdge && version <= 79)
        ) {
            this.$bvModal.show('modal-browser');
            this.browserNotSupported = true;
        }
        
        this.userProcessModalTitle = 'Process Details for ' + this.$store.state.user.Username;
        console.log("mount app")
        this.connection.on("status", (data: string) => {
            console.log("status: app");                    
            let dataParsed: Array<Process> = JSON.parse(data);                  
            console.log(dataParsed)    
            console.log(this.$store.state.user.Username);
            let processList = dataParsed.filter(process => process.Username.toLowerCase() === this.$store.state.user.Username.toLowerCase());                
            console.log("---"); 
            console.log(processList)  ;
            this.$store.dispatch('addProcess',processList);
            
        });
        if(this.sideMenuRef){
            let currentClaim = this.sideMenuRef.getCurrentMenuItem()?.Claim;
            console.log(currentClaim)
            console.log(this.$router.currentRoute.path)
            
            if (currentClaim!="" && !General.CheckAuthorization(currentClaim)){                 
                General.GoToHP();
            };
        }
        
        if(this.isEmergencyContactExpired){
            this.$bvModal.show('bv-modal-emergency-popup')
        } 
    }
    
    async updateCultureUserAsync(selectedLanguage: string){
        try {
            axios.post<any>(General.GetApiUrl("/api/userprofile/UpdateUserProfileCulture"), {
            idCulture: selectedLanguage
        },{
            withCredentials: true,
            responseType: 'json'
        })
        } catch (error) {                
            General.HandleError(error, this);
        }
    } 

    async changeLanguage(value: string){
        this.selectedLanguage = value;
        let languageSelected : string = this.selectedLanguage
        
        let isConfirmed = false;
        if(languageSelected != null){
            General.confirm( "Are you sure to change language?", this, async () => {
            await this.changeLanguageDo(languageSelected)
            try{
                await General.SetUser();             
            }catch{}

            isConfirmed = true;
        });

    
        //if(!isConfirmed) this.selectedLanguage = this.languageOptions[0].idCulture;    

        }
    }
    async changeLanguageDo(languageSelected: string){       
        this.$store.commit("SET_USER_CULTURE", languageSelected);
        await this.updateCultureUserAsync(languageSelected);
        await General.loadLanguageAsync(languageSelected);
        this.selectedLanguage = languageSelected;
    }

    @Watch('communications')
    onPropertyChanged(value: string, oldValue: string) {
        this.showCommunicationModal();
    }


    
    // @Watch('communications.length')cancellami(value: number, oldValue: number){
    //    if(value == 0)
    //    alert("non ci sono pi+ comm!!!")
    // }

    get classForTopNavComponent(){
        if (this.communications!=null && !this.isHidingCommunicationsDuringImpersonation && this.isNeededTopNavbar){
            return 'nav_menu bg-white float-none z-index-1100';
        }
        return 'nav_menu bg-white float-none';
    }

    get navTitleClass(){
        if (this.communications!=null && !this.isHidingCommunicationsDuringImpersonation && this.isImpersonating){
            return 'z-index-1100';
        }
        return '';

        
    }

    
    isDropdownActive: boolean = false;
    toggleDropdown(){
        this.isDropdownActive = !this.isDropdownActive;
        let arrowDropdown = document.getElementById("arrowDropdown");
        if (this.isDropdownActive){
            arrowDropdown.classList.add("rotate-90-deg");
        }
        else{
            arrowDropdown.classList.remove("rotate-90-deg");
        }
    }
    collapseDropdown(){
        let arrowDropdown = document.getElementById("arrowDropdown");
        if (this.isDropdownActive){
            this.isDropdownActive = false;
            arrowDropdown.classList.remove("rotate-90-deg");
        }
    }
    checkCommmunication(commId:string):boolean{
        let check =  this.userActionHashMap.has(commId);
        if (check==false) this.commToConfirm = commId;
        return check;
       
    }     
}
